import { render, staticRenderFns } from "./home_page.vue?vue&type=template&id=f61b6fac&scoped=true&lang=pug"
import script from "./home_page.vue?vue&type=script&lang=js"
export * from "./home_page.vue?vue&type=script&lang=js"
import style0 from "./home_page.vue?vue&type=style&index=0&id=f61b6fac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61b6fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61b6fac')) {
      api.createRecord('f61b6fac', component.options)
    } else {
      api.reload('f61b6fac', component.options)
    }
    module.hot.accept("./home_page.vue?vue&type=template&id=f61b6fac&scoped=true&lang=pug", function () {
      api.rerender('f61b6fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/home_page/home_page.vue"
export default component.exports